export default "__VITE_ASSET__W6QjpOLJimIX6J6nneBG0g__"